/**
 * @generated SignedSource<<2bfef8a2ff1257d95a7ca01badc51d71>>
 * @relayHash 73520ae724cd725d1b8a9eaf5e2c16fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2757426f0a0e166111d8064199946a10478bc2b410dc09def2c817aed218a3c8

import type { ConcreteRequest, Query } from 'relay-runtime';
export type profileMenuQuery$variables = {
  includeExtraMenuItems: boolean;
};
export type profileMenuQuery$data = {
  readonly me: {
    readonly user: {
      readonly email?: string | null | undefined;
      readonly name?: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  };
};
export type profileMenuQuery = {
  response: profileMenuQuery$data;
  variables: profileMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeExtraMenuItems"
  }
],
v1 = {
  "condition": "includeExtraMenuItems",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "email"
        }
      ],
      "type": "AtlassianAccountUser"
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "profileMenuQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "profileMenuQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2757426f0a0e166111d8064199946a10478bc2b410dc09def2c817aed218a3c8",
    "metadata": {},
    "name": "profileMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e34dc1e934909689cced70f51a578ad5";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
